import _ from 'lodash'
import { isDatasetWidgetModel } from './maestro'
import isRtl from '../../components/is-rtl'

function createWob (canvas, widget, opt, bootslideMenu) {
	opt = _.defaults(opt || {}, { fetchData: true })

	var wobs = canvas.collection.map(function (wob) {
		return wob.pick('left', 'top', 'width')
	})

	let wobWidth =
		// This specific widget instance might have a width specified
		opt.wobAttributes?.width
		// If not, the widget type might have a default width
		?? widget.containerDefaults?.width
		// Fall back on the default from canvas's WobView.defaults()
		?? 200

	let placement = place({
		wobs,
		defaults,
		position: canvas.$el.position(),
		minCanvasWidth: canvas.minWidth,
		wobWidth,
		visibleWidth: canvas.$el.parent().width(),
		rtl: isRtl()
	})

	var wob = _.extend({
		widget: widget
	}, placement, opt.wobAttributes)

	canvas.create(wob)

	opt.fetchData && widget.data.fetch({periodId: widget.options.getPeriodId()})

	let wobView = _(canvas.views).values()
		.find(wobView => wobView.view.model === widget)

	// Adding a dataset widget may require a dataset query
	if (isDatasetWidgetModel(widget)) {
		let type = widget.get('type')
		let datasetId = widget.datasetId()
		if (type === 'dataset-filter'
			&& widget.filter().operator === 'in-period') {

			// #24995 most default filter widgets won't change the query results,
			// but date filters default to "current period", so we need to do
			// a fetch for all the widgets using that dataset
			bootslideMenu.model.maestro.query(datasetId)
		} else {
			bootslideMenu.model.maestro.query(datasetId, wobView.view)
		}
	}

	if (!_.isNil(bootslideMenu)) bootslideMenu.previewSelection()

	return wobView
}

var defaults = {
	left: 130,
	top: 130
}

// Returns appropriate coordinates to prevent a new wob totally overlapping
// an existing wob. Shifts down-right by increments of 10 until it find space
function place ({ wobs, defaults, position, minCanvasWidth, rtl, wobWidth, visibleWidth }) {
	let attempt = { top: defaults.top - position.top }
	if (rtl) {
		let canvasWidth = getCanvasWidth({ minCanvasWidth, wobs })

		let visibleTopRight = canvasWidth < visibleWidth
			// We can see the whole canvas, so the top-right is based on the
			// whole canvas width
			? canvasWidth
			// We can't see the whole canvas, so the top-right is based on the
			// viewable area of the canvas and the distance it is scrolled
			// to the right
			: visibleWidth - position.left
		attempt.left = visibleTopRight - defaults.left - wobWidth
	} else {
		// Start position in viewable area. Issue #28050
		attempt.left = defaults.left - position.left
	}

	while (true) {
		if (_.find(wobs, conflict.bind(null, attempt))) {
			// If there's already wob at this exact position, move it
			// down and to the right (or left, if in RTL) and check again
			attempt = {
				left: rtl
					? attempt.left - 10
					: attempt.left + 10,
				top: attempt.top + 10
			}
		} else {
			return attempt
		}
	}
}

function getCanvasWidth ({ minCanvasWidth, wobs }) {
	let maxRight = _(wobs).map(w => w.left + w.width).max() ?? 0
	return Math.max(minCanvasWidth, maxRight)
}

function conflict (a, b) {
	return a.left === b.left && a.top === b.top
}

export default createWob
// just exporting this for unit tests
export { place }

createWob.__filename__ = 'dashboards/widgets/create-wob.js'
